import { memo } from 'react';

import { FormIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';
import { Tooltip } from '@air/primitive-tooltip';

import { usePublicCustomFieldsPanel } from '~/components/PublicBoard/components/PublicBoardCustomFieldsPanelContent/hooks/usePublicCustomFieldsPanel';

export const PublicBoardHeaderActionsCustomFieldsButton = memo(() => {
  const { togglePanel } = usePublicCustomFieldsPanel();

  const label = 'View custom fields';

  if (!togglePanel) {
    return null;
  }

  return (
    <Tooltip label={label}>
      <IconButton
        adsIcon
        appearance="ghost"
        color="gray"
        data-testid="PUBLIC_CUSTOM_FIELDS_BUTTON"
        icon={FormIcon}
        label={label}
        onClick={togglePanel}
        size="medium"
      />
    </Tooltip>
  );
});

PublicBoardHeaderActionsCustomFieldsButton.displayName = 'PublicBoardHeaderActionsCustomFieldsButton';
